import type { EmptyStateProps } from './WalletDetails.types';
import type { ReactElement } from 'react';

import { Button, Flex, Heading, Text } from '@rango-dev/whale';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks';
import { setHideEmptyWallets } from '../../state/WalletDetailsSlice';

import styles from './EmptyState.module.css';

export function EmptyState(props: EmptyStateProps): ReactElement {
  const { emptyWalletsCount } = props;
  const { hideEmptyWallets } = useAppSelector((state) => state.walletDetails);
  const dispatch = useAppDispatch();
  const { isDarkMode } = useAppSelector((state) => state.settings);

  const { t } = useTranslation();

  return (
    <Flex direction="column" align="center" gap="4" height="100%" p="4" className={styles.center}>
      <img
        src={`/imgs/illustrations/empty-${isDarkMode ? 'dark' : 'light'}.svg`}
        alt="empty"
        className={styles.image}
      />
      <Heading size="4">{t('No results found')}</Heading>
      {hideEmptyWallets && emptyWalletsCount > 0 ? (
        <>
          <Text size="2" color="gray" align="center" className={styles.description}>
            {t(
              'No wallet to show, You have only {{emptyWalletsCount}} empty wallets. Select more chains / wallets or enable showing empty wallets to view your balance.',
              { emptyWalletsCount },
            )}
          </Text>
          <Button
            id="wallet-details-modal-show-empty-wallet-btn"
            size="2"
            variant="outline"
            radius="full"
            onClick={() => dispatch(setHideEmptyWallets(false))}>
            {t('Show empty wallets')}
          </Button>
        </>
      ) : (
        <Text size="2" color="gray" align="center" className={styles.description}>
          {t('Select more chains or wallets to view your balance')}
        </Text>
      )}
    </Flex>
  );
}
